import { createContext } from "react";

const WalletTransferHistoryContext = createContext();

export default WalletTransferHistoryContext;
